//(function () {
//    'use strict';
//
//    angular
//        .module('sodCommon')
//        .directive('sodCopyText', sodCopyText);
//
//    function sodCopyText() {
//        return {
//            restrict: 'A',
//            link: function(elem) {
//                var copyArea = elem.select();
//                try {
//                    var successful = document.execCommand('copy');
//                    if (successful) {
//
//                    } else {
//
//                    }
//                } catch (err) {
//                    console.warn('Opps, unable to copy');
//                }
//            }
//        }
//    }
//})();